export default __webpack_public_path__ + "static/media/ch_5.05784e63.mp3";